import React from "react";
// import { cropr, Wkt } from "./../../legacy";
import sensorActions from "./../../actions/sensorActions";
import { useDispatch } from "react-redux";
import { iconSwitch } from "./../../utils/mapUtils";
import { Map as LeafletMap, Marker, TileLayer } from "react-leaflet";

const Map = ({ className, sensor, draggable }) => {
  const dispatch = useDispatch();

  // @TODO mirgate: add cropr fields to map
  // Add fields to the map
  //   if (Wkt) {
  //     var wkt = new Wkt.Wkt();
  //     cropr.cropfields.each(function (feature) {
  //       if (feature.get("geometry")) {
  //         wkt.read(feature.get("geometry"));
  //         wkt.toObject(feature.get("style")).addTo(mapRef.current);
  //       }
  //     });
  //   }

  return (
    <LeafletMap
      center={
        !sensor.errors.latitude && !sensor.errors.longitude
          ? [sensor.latitude, sensor.longitude]
          : undefined
      }
      id="map"
      className={className}
      zoom={sensor.latitude === 0 && sensor.longitude === 0 ? 2 : 16}
      boundsOptions={{ padding: [5, 5] }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />

      <Marker
        draggable={draggable}
        onDragend={(event) => {
          var marker = event.target; // you could also simply access the marker through the closure
          var result = marker.getLatLng(); // but using the passed event is cleaner
          dispatch(sensorActions.updateLatitude(result.lat.toFixed(5)));
          dispatch(sensorActions.updateLongitude(result.lng.toFixed(5)));
        }}
        key={sensor.id}
        icon={iconSwitch(sensor, draggable)}
        position={[sensor.latitude, sensor.longitude]}
      ></Marker>
    </LeafletMap>
  );
};

export default Map;
